import React from "react";
import Phone from "./Phone";
import useCountUp from "../hooks/useCountUp";

const R = 34;
const C = 2 * Math.PI * R;

/** Pulled's home screen, running. */
export default function ScreenPulled({ active }) {
  const cp = useCountUp(1240, active, { duration: 1900, delay: 260 });
  const streak = useCountUp(12, active, { duration: 1200, delay: 420 });
  const pct = Math.min(1, cp / 1600);

  return (
    <Phone tint="#fbca57" label="The Pulled home screen: 1,240 confidence points and a 12-day streak.">
      <div className={`ui ui--pulled${active ? " is-live" : ""}`}>
        <header className="ui__top">
          <div>
            <span className="ui__kicker">Stage 3</span>
            <strong className="ui__h">Flirting</strong>
          </div>
          <span className="ui__streak">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2c1 4-3 5-3 8a3 3 0 0 0 6 0c0-1-.5-2-.5-2 2 1.5 3.5 3.5 3.5 6a6 6 0 0 1-12 0C6 9 12 8 12 2Z" />
            </svg>
            {streak}
          </span>
        </header>

        <section className="ui__ring">
          <svg viewBox="0 0 84 84" aria-hidden="true">
            <circle className="ui__ring-bg" cx="42" cy="42" r={R} />
            <circle
              className="ui__ring-fg"
              cx="42"
              cy="42"
              r={R}
              strokeDasharray={C}
              strokeDashoffset={C * (1 - pct)}
            />
          </svg>
          <div className="ui__ring-mid">
            <strong>{cp.toLocaleString()}</strong>
            <span>confidence pts</span>
          </div>
        </section>

        <section className="ui__card ui__card--challenge">
          <span className="ui__label">Today’s challenge</span>
          <p>Ask three strangers for directions.</p>
          <div className="ui__ticks">
            {[0, 1, 2].map((i) => (
              <span key={i} className="ui__tick" style={{ "--d": `${900 + i * 260}ms` }}>
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path d="M3 8.5 6.4 12 13 4.5" />
                </svg>
              </span>
            ))}
            <em>+120 CP</em>
          </div>
        </section>

        <section className="ui__roster">
          <span className="ui__label">Roster</span>
          {[
            ["Sofia", "Coffee queue", 9],
            ["Amelia", "Bookshop", 7],
            ["Nadia", "Gallery, Friday", 8],
            ["Priya", "Gym, Tuesday", 8],
          ].map(([name, where, score], i) => (
            <div className="ui__row" key={name} style={{ "--d": `${1150 + i * 140}ms` }}>
              <span className="ui__avatar">{name[0]}</span>
              <span className="ui__row-txt">
                <b>{name}</b>
                <i>{where}</i>
              </span>
              <span className="ui__score">{score}.0</span>
            </div>
          ))}
        </section>

        <nav className="ui__tabs" aria-hidden="true">
          {["Learn", "Do", "Roster", "You"].map((t, i) => (
            <span key={t} data-on={i === 1 || undefined}>
              {t}
            </span>
          ))}
        </nav>
      </div>
    </Phone>
  );
}
